import { Caption, Textarea } from '@telegram-apps/telegram-ui';

import styles from './QuestionField.module.css';

/**
 * QuestionField — карточка ввода вопроса (work-020, DESIGN §7 «Textarea»).
 *
 * «Глупый» презентационный компонент: БЕЗ хуков, БЕЗ MainButton, без сабмита —
 * только разметка/стили поля. Вынесен 1-в-1 из AskScreen, чтобы AskScreen и
 * AskByCodeScreen использовали одну форму (DRY), не плодя владельцев нативной
 * кнопки (решение 4 work-020).
 *
 * В тёмной теме Telegram `section_bg == bg` → нативная рамка FormInput кита
 * сливается с фоном. Поэтому оборачиваем Textarea в свою карточку `.field`
 * (фон secondary_bg + radius card-12, DESIGN §5), а фон/рамку/радиус самого кита
 * внутри гасим. Счётчик и текст ошибки — компактная строка `.meta` внизу карточки.
 * Ошибка — красная inset-рамка вокруг ВСЕЙ карточки (не обрезается overflow:hidden).
 */
export interface QuestionFieldProps {
  value: string;
  onChange: (value: string) => void;
  maxLength: number;
  /** Текст ошибки — рисует красную рамку карточки + сообщение слева в `.meta`. */
  error?: string;
  /** Блокировка ввода на время отправки. */
  disabled?: boolean;
  /** Плейсхолдер Textarea. */
  placeholder?: string;
}

export function QuestionField({
  value,
  onChange,
  maxLength,
  error,
  disabled = false,
  placeholder,
}: QuestionFieldProps) {
  const hasError = error !== undefined && error.length > 0;
  return (
    <div className={hasError ? `${styles.field} ${styles.fieldError}` : styles.field}>
      <Textarea
        className={styles.input}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={maxLength}
        placeholder={placeholder}
        disabled={disabled}
        rows={4}
        status={hasError ? 'error' : 'default'}
      />
      <div className={styles.meta}>
        {hasError ? (
          <Caption Component="span" role="alert" className={styles.errorMsg}>
            {error}
          </Caption>
        ) : (
          <span />
        )}
        <Caption Component="span" className={styles.counter}>
          {value.length} / {maxLength}
        </Caption>
      </div>
    </div>
  );
}
